var map = {
	"./AI-banner.png": "90c1",
	"./AI-bg-1.png": "5e5e",
	"./AI-bg-2.png": "8240",
	"./aboutUs-banner.png": "792b",
	"./aboutUs-text.png": "3c2c",
	"./address.png": "705f",
	"./answer-icon.png": "a4b2",
	"./appliedTechnology.png": "2835",
	"./auxiliary-banner.png": "c3bb",
	"./available.png": "12f1",
	"./clinical.png": "0f53",
	"./clinician.png": "9d19",
	"./contradiction.png": "74b8",
	"./cooperate-bg.png": "4e0a",
	"./diagnosis-diagnosis.png": "88e4",
	"./diagnosis-framework.png": "f24d",
	"./diagnosis-knowledgebase.png": "86a1",
	"./diagnosis-programme.png": "49aa",
	"./diagnosis.png": "dcec",
	"./dispute.png": "ad16",
	"./down.png": "7c7c",
	"./examine.png": "2564",
	"./guidance-icon.png": "5007",
	"./home-banner.png": "89dc",
	"./knowledge.png": "aaf4",
	"./knowledgebase-bg.png": "326d",
	"./logo-title.png": "ba43",
	"./logo.png": "9d64",
	"./phone.png": "1e37",
	"./protest.png": "35de",
	"./qrcode.png": "a76d",
	"./quality.png": "5509",
	"./qualityController.png": "1df1",
	"./shaoyifu-icon.png": "fbae",
	"./shaoyifu-logo.png": "2bc2",
	"./shengrenmin-icon.png": "da2e",
	"./shengrenmin-logo.png": "0774",
	"./stories-banner.png": "1cbb",
	"./structural.png": "9fbe",
	"./support.png": "a884",
	"./synergy.png": "9851",
	"./systemFramework.png": "f1e9",
	"./technology-item-bg.png": "3cb5",
	"./top-b.png": "02bd",
	"./top-w.png": "d648"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";